import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";
import { spacing } from "../../../../../../../../../assets/styles/tokens";
import NegativeBalanceCard from "./NegativeBalanceCard";

// ─── Formatters ──────────────────────────────────────────────────────────────
// Null/undefined metric values are shown as a dash, never zero.
const DASH = "-";

// Plain text/number — dash when missing.
const formatText = (value: any): string =>
  value === null || value === undefined || value === "" ? DASH : String(value);

// Money: rounded, 1000-separated, negative as -$100, positive as $100 (dash when missing).
const formatCurrency = (value: any): string => {
  if (value === null || value === undefined || value === "") return DASH;
  const num = Number(String(value).replace(/[, ]/g, ""));
  if (Number.isNaN(num)) return DASH;
  const formatted = Math.abs(Math.round(num)).toLocaleString("en-US");
  return num < 0 ? `-$${formatted}` : `$${formatted}`;
};

// Calculated Total Income chip: red when the balance is negative, else green.
const balanceStatus = (value: any): "success" | "error" => {
  const num = Number(String(value ?? "").replace(/[, ]/g, ""));
  return Number.isFinite(num) && num < 0 ? "error" : "success";
};
// ─────────────────────────────────────────────────────────────────────────────

const NegativeBalanceItem = ({ data = [] }: { data?: any[] }) => {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography textAlign="center" fontSize="14px" color="text.secondary">
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {data.map((item: any, index: number) => (
            <NegativeBalanceCard
              key={item.brand_id ?? index}
              brandName={formatText(item.brand_names)}
              brandId={formatText(item.brand_id)}
              calculatedTotalIncome={formatCurrency(
                item.calculate_total_income,
              )}
              calculatedTotalIncomeStatus={balanceStatus(
                item.calculate_total_income,
              )}
              lastMonthEndBalance={formatCurrency(item.balance_end_last_month)}
              totalIncome={formatCurrency(item.totalincome_dollar)}
              cpaIncome={formatCurrency(item.cpa_dollar)}
              rsIncome={formatCurrency(item.revshare_dollar)}
              clickOut={formatText(item.clicks)}
              regs={formatText(item.reg)}
              ftd={formatText(item.ftd)}
              qftd={formatText(item.qftd)}
              brandPolicyPlan={formatText(item.brand_policy_plan_name)}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default NegativeBalanceItem;
